export default __webpack_public_path__ + "static/media/colors.cf4ac382.svg";